import React from "react";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
import { ProductReplacement } from "../ProductDetailPageResult";

interface Props {
  productReplacement: ProductReplacement;
  containsQuantityDropdown?: boolean;
  showQuantityDropdown?: boolean;
}

const ViewReplacementButton = ({
  productReplacement,
  containsQuantityDropdown,
  showQuantityDropdown,
}: Props) => {
  const { replacementLink } = productReplacement;

  const handleViewReplacementClick = (event: React.SyntheticEvent) => {
    event?.preventDefault();

    setWindowLocationHref(replacementLink);
  };

  return (
    <div
      className={`add-to-cart ${
        !showQuantityDropdown && containsQuantityDropdown ? "absolute" : ""
      }`}
      style={
        !showQuantityDropdown && containsQuantityDropdown
          ? { bottom: "7px", width: "130px" }
          : {}
      }
    >
      <div className="btn-container p-0">
        <input
          type="button"
          className="btn btn-info btn-small btn-mini-replacement-item"
          value="View Replacement"
          onClick={handleViewReplacementClick}
          data-testid="carousel-view-replacement-button"
        />
      </div>
    </div>
  );
};

export default ViewReplacementButton;
